import type { AllFeatureIds } from 'generated/featureIds.generated'
import { AtsJobPostingStatusesEnum } from 'generated/resources/graphql'
import { some } from 'lodash'

import hasFeature from 'modules/core/lib/hasFeature'

import { Provider } from 'modules/ats/lib/enums'
import { JobTarget } from 'modules/ats/pages/JobPostingPromotion/JobBoards/Providers/JobTarget'
import { LinkedinLimitedListings } from 'modules/ats/pages/JobPostingPromotion/JobBoards/Providers/LinkedinLimitedListings'
import { Vonq } from 'modules/ats/pages/JobPostingPromotion/JobBoards/Providers/Vonq'
import { WelcomeToTheJungle } from 'modules/ats/pages/JobPostingPromotion/JobBoards/Providers/WelcomeToTheJungle'

import { ProviderComponentProps } from './JobBoards/JobBoardCard'

interface AtsIntegration {
  id: number
  integrationId: number
  formData?: string | null
}
export interface AtsIntegrations {
  [key: string]: AtsIntegration
}

export const PROMOTION_PROVIDERS: PromotionProviderInfo[] = [
  {
    provider: Provider.LinkedinLimitedListings,
    component: LinkedinLimitedListings,
    feature: null,
  },
  { provider: Provider.JobTarget, component: JobTarget, feature: 'ats_promote_jobtarget' },
  { provider: Provider.Vonq, component: Vonq, feature: 'ats_promote_vonq' },
  {
    provider: Provider.WelcomeToTheJungle,
    component: WelcomeToTheJungle,
    feature: null,
  },
]

export interface PromotionProviderInfo {
  provider: Provider
  component: (props: ProviderComponentProps) => JSX.Element | null
  feature: AllFeatureIds | null
}

export const hasJobBoards = (isPublished: boolean) => {
  return (
    isPublished &&
    some(
      PROMOTION_PROVIDERS.map(
        (info: PromotionProviderInfo) => !info.feature || hasFeature(info.feature)
      )
    )
  )
}

export const hasJobPromotion = (status: AtsJobPostingStatusesEnum) => {
  return (
    some(
      PROMOTION_PROVIDERS.map(
        (info: PromotionProviderInfo) => !info.feature || hasFeature(info.feature)
      )
    ) && status === 'published'
  )
}
